import TaskManagerEditDto from './TaskManagerEditDto';

export class PiWriterTaskEditDto extends TaskManagerEditDto {
    constructor() {
        super();

        /** @type {number} */
        this.piWriter = null;

        /** @type {number} */
        this.optimizationPipeline = null;
    }

    /**
     * @typedef {Object} _PiWriterTaskEditDto  Props
     * @property {number} piWriter
     * @property {number} optimizationPipeline
     *
     * @typedef {import("./TaskManagerEditDto").TaskManagerEditDtoProps & _PiWriterTaskEditDto Props} PiWriterTaskEditDto Props
     */
    /**
     *
     * @param {PiWriterTaskEditDto Props} props
     * @returns {PiWriterTaskEditDto}
     */
    setup(props) {
        super.setup(props);

        this.piWriter = props.piWriter;
        this.optimizationPipeline = props.optimizationPipeline;

        return this;
    }
}

export default PiWriterTaskEditDto;